import { Inject, Injectable, InjectionToken } from '@angular/core';
import { DictionaryService, isset, takeUntilDestroyed } from '@cawita/core-front';
import { CwtStorageService } from '@cawita/core-front/storage';
import { TranslateService } from '@ngx-translate/core';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { tap } from 'rxjs/operators';
import { CwtLanguageConfig, CWT_LANGUAGE_CONFIG } from './language.config';

@Injectable()
export class CwtLanguageService {
    public get current() { return this.translate.currentLang; }
    public get locales(): string[] { return this.language.locales; }
    public get default(): string { return this.language.default; }
    public get localeId(): string { return this.translate.instant('locale-id') ?? 'fr-FR'; }

    constructor(
        @Inject(CWT_LANGUAGE_CONFIG) protected language: CwtLanguageConfig,
        private storage: CwtStorageService,
        private translate: TranslateService,
        private dictionary: DictionaryService,
        private i18n: NzI18nService,
    ) {
        // this.translate.stream('zorro').pipe(
        //     filter(i => !!i),
        //     takeUntilDestroyed(this)
        // ).subscribe(i => this.i18n.setLocale(i));
    }

    public init() {
        this.translate.setDefaultLang(this.default);
        this.dictionary.defaultLocale = this.default;
        const storedLanguage = this.storage.getString(this.language.storageKey);
        if (isset(storedLanguage)) return this.use(storedLanguage);
        const browserLocale = navigator.language;
        if (isset(browserLocale)) {
            const locale = browserLocale.trim().split(/-|_/)[0];
            if (this.locales.includes(locale)) return this.use(locale);
        }

        return this.use(this.default);
    }

    public use(locale: string) {
        if (!isset(locale)) locale = this.default;
        return this.translate.use(locale).pipe(
            tap(() => this.dictionary.locale = locale),
            tap(() => this.storage.setString(this.language.storageKey, locale))
        )
    }
}
